export const CAPTURES_COLLECTION = 'captures';
export const CAPTURE_EXTRACTION_VERSION = 'capture-persistence-v1';

export const CAPTURE_PROCESSING_STATUSES = Object.freeze({
  PENDING_PROCESSING: 'pending_processing',
  PROCESSING: 'processing',
  REVIEW_READY: 'review_ready',
  SAVED: 'saved',
  FAILED: 'failed',
});

export const buildEmptyCaptureArtifactCounts = () => ({
  timeline_event: 0,
  medication_update: 0,
  knowledge_item: 0,
  goal: 0,
  document_reference: 0,
});

const normalizeText = (value = '') => String(value || '').trim();

export const buildCapturePayload = ({
  childId = '',
  userId = '',
  sourceType = 'unknown',
  sourceText = '',
  originalText = '',
  inputContext = {},
  metadata = {},
  status = CAPTURE_PROCESSING_STATUSES.PENDING_PROCESSING,
  now,
} = {}) => ({
  childId: normalizeText(childId),
  userId: normalizeText(userId),
  sourceType: normalizeText(sourceType) || 'unknown',
  sourceText: normalizeText(sourceText),
  originalText: normalizeText(originalText || sourceText),
  inputContext: inputContext && typeof inputContext === 'object' && !Array.isArray(inputContext)
    ? inputContext
    : {},
  extractionVersion: CAPTURE_EXTRACTION_VERSION,
  status,
  processingStartedAt: null,
  processingCompletedAt: null,
  processingError: null,
  artifactCounts: buildEmptyCaptureArtifactCounts(),
  metadata: metadata && typeof metadata === 'object' && !Array.isArray(metadata)
    ? metadata
    : {},
  createdAt: now,
  updatedAt: now,
});

export const buildCaptureTimelineFields = ({
  captureId = '',
  extractionVersion = CAPTURE_EXTRACTION_VERSION,
  editedByUser = false,
  sourceBlockId = null,
  sourceSentenceIndex = null,
} = {}) => {
  const fields = {
    captureId: normalizeText(captureId),
    extractionVersion: normalizeText(extractionVersion) || CAPTURE_EXTRACTION_VERSION,
    editedByUser: Boolean(editedByUser),
  };

  const cleanSourceBlockId = normalizeText(sourceBlockId);
  if (cleanSourceBlockId) {
    fields.sourceBlockId = cleanSourceBlockId;
  }

  if (Number.isInteger(sourceSentenceIndex)) {
    fields.sourceSentenceIndex = sourceSentenceIndex;
  }

  return fields.captureId ? fields : {};
};
